import type { ReactNode } from 'react';
import { useT } from '../i18n';
import type { SiteData } from '../useSiteData';
import { useSiteData } from '../useSiteData';

/** 页面统一入口：数据未就绪时显示加载或错误，就绪后把数据交给渲染函数。 */
export function WithSiteData({ children }: { children: (d: SiteData) => ReactNode }) {
  const { t } = useT();
  const s = useSiteData();
  if (s.error) {
    return (
      <div className="mx-auto max-w-6xl px-5 py-24">
        <div className="rounded-xl border border-danger/40 bg-danger/10 p-6">
          <div className="font-semibold text-danger-light">{t('error.title')}</div>
          <p className="mt-2 text-sm text-muted">{s.error}</p>
        </div>
      </div>
    );
  }
  if (!s.data) {
    return <div className="mx-auto max-w-6xl px-5 py-24 text-muted">{t('state.loading')}</div>;
  }
  return <>{children(s.data)}</>;
}

/** 装饰性标签。 */
export function Tag({ children, tone = 'muted' }: { children: ReactNode; tone?: 'muted' | 'warn' }) {
  const cls =
    tone === 'warn'
      ? 'border-warn/40 bg-warn/10 text-warn-light'
      : 'border-line bg-surface text-muted-light';
  return <span className={`inline-block rounded border px-2 py-0.5 text-xs whitespace-nowrap ${cls}`}>{children}</span>;
}
